import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLayerGroup, faBook } from "@fortawesome/free-solid-svg-icons";

const Bundle = props => {
  const { bundleCount, className } = props;
  return (
    <div className={`bundle${className ? ` ${className}` : ""}`}>
      {bundleCount > 1 ? (
        <span>
          <FontAwesomeIcon icon={faLayerGroup} className="me-1" />
          <span>{`${bundleCount} Course Bundle`}</span>
        </span>
      ) : (
        <span>
          <FontAwesomeIcon icon={faBook} className="me-1" />
          <span>Single Course</span>
        </span>
      )}
    </div>
  );
};

Bundle.propTypes = {
  bundleCount: PropTypes.number,
  className: PropTypes.string
};
Bundle.defaultProps = {
  bundleCount: null,
  className: null
};

export default Bundle;
